module.exports = __webpack_public_path__ + "img/login.7109b6b5.svg";